class FooterController {
 
}
  
export default FooterController;
  


// WEBPACK FOOTER //
// ./client/app/shared/ui/app-footer/app-footer.controller.js